<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="onStore"
  >
    <form
      @submit.stop.prevent="onStore"
      @keydown="form.errors.clear($event.target.name)"
    >
    <b-col>
      <label>Valor frete</label>
      <currency-input
         class="form-control"
         v-model="form.vlr_frete"
         :auto-decimal-mode="true"
         placeholder="Valor frete"
         :currency="{ prefix: ''}"
         :distraction-free="getCurrency"/>
      <b-form-feedback
        v-text="form.errors.get('vlr_frete')"
        v-if="form.errors.has('vlr_frete')"
      ></b-form-feedback>
    </b-col>
    <label>Observação</label>
    <b-form-textarea
      v-model="form.obs"
      class="form-control"
      name="obs"
      placeholder="Observação"
      :rows="3"
      :max-rows="6"
    >
    </b-form-textarea>
    <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      errors_array: [],
      data: [],
      form: new Form({
        carga_id: "",
        vlr_frete: 0,
        obs: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    codOcorrencia(obj) {
      this.fileForm.cd_ocorrencia = obj.value;
    }
  },
  methods: {
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Frete avulso";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.form.reset();
      this.form.vlr_frete = 0;
      this.form.carga_id = data.cargaId;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.$parent.permiteGerarDespesa = false;
      this.form
        .post("/api/expedicao/avulso")
        .then(response => {
          new ReturnApi(response, this, true, null, null, true);
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
